import { all } from 'redux-saga/effects';
import authSaga from './auth/saga';
import payrollSaga from './payroll/saga';
import payrunSaga from './payrun/saga';
import salaryAdditionSaga from './salaryaddition/saga';
import salaryAdjustmentSaga from './salaryadjustment/saga';
import salaryDeductionSaga from './salarydeduction/saga';
import employeeSaga from './employee/saga';
import salarySaga from './salary/saga';
import reportSaga from './report/saga';
import holidaySaga from './holiday/saga';
import clientSaga from './client/saga';
import chargeRateSaga from './chargerate/saga';
import finalPaySaga from './finalpay/saga';
import optionlistSaga from './optionlist/saga';
import accessRightSaga from './accessright/saga';
import userSaga from './user/saga';
import accessGroupSaga from './accessgroup/saga';
import moduleSaga from './module/saga';
import accessGroupUserSaga from './accessgroupuser/saga';
import timeCardSaga from './timecard/saga';
import leaveSaga from './leave/saga';
import overtimeSaga from './overtime/saga';
import trainingModulesSaga from './trainingmodule/saga';
import jobRoleSaga from './jobrole/saga';
import trainingModuleRequestSaga from './trainingmodulerequest/saga';
import trainingClassSaga from './trainingclass/saga';
import jobRoleRequestSaga from './jobrolerequest/saga';
import overviewSaga from './overview/saga';
import awardSaga from './award/saga';
import employeeAwardSaga from './employeeaward/saga';
import jobPostSaga from './jobpost/saga';
import trainingClassCertificationSaga from './trainingclasscertification/saga';
import faqSaga from './faq/saga';
import recruitementSaga from './recruitment/saga';
import rewardSaga from './reward/saga';
import employeeRewardSaga from './employeereward/saga';
import recognitionWallSaga from './recognitionwall/saga';
import userReactionSaga from './userreaction/saga';
import ticketSaga from './supportticket/saga';
import ticketReplySaga from './ticketreply/saga';

function* rootSaga() {
  yield all([
    authSaga(),
    payrollSaga(),
    payrunSaga(),
    salaryAdditionSaga(),
    salaryAdjustmentSaga(),
    salaryDeductionSaga(),
    employeeSaga(),
    salarySaga(),
    reportSaga(),
    holidaySaga(),
    clientSaga(),
    chargeRateSaga(),
    finalPaySaga(),
    optionlistSaga(),
    accessRightSaga(),
    userSaga(),
    accessGroupSaga(),
    moduleSaga(),
    accessGroupUserSaga(),
    timeCardSaga(),
    leaveSaga(),
    overtimeSaga(),
    trainingModulesSaga(),
    jobRoleSaga(),
    trainingModuleRequestSaga(),
    trainingClassSaga(),
    jobRoleRequestSaga(),
    overviewSaga(),
    awardSaga(),
    employeeAwardSaga(),
    jobPostSaga(),
    trainingClassCertificationSaga(),
    faqSaga(),
    recruitementSaga(),
    rewardSaga(),
    employeeRewardSaga(),
    recognitionWallSaga(),
    userReactionSaga(),
    ticketSaga(),
    ticketReplySaga(),
  ]);
}

export default rootSaga;
